import { UserCard } from "@/components/user-card/UserCard.tsx";
import useFormatter from "@/hooks/use-formatter.hook.ts";
import { TeamTabComponentProps } from "@/pages/employees/team/components/team-tab-components.types.ts";
import { getEmployeePositionTitle } from "@/types/employees/employee-position.types.ts";
import { getEmployeeAvatarUrl } from "@/types/employees/employee.types.ts";
import { TeamMemberRoleItems, TeamMemberRoleType } from "@/types/team.types.ts";
import { Stack, Text } from "@skailer-com/uikit";

export default function TeamTabOverview({ team }: TeamTabComponentProps) {
  const { renderEmployeeName } = useFormatter();
  return (
    <Stack direction={"horizontal"} gap={"2xl"} className="flex-wrap">
      {team.members.map((member) => {
        const division = member.employee.employee_position?.division;
        const department = member.employee.employee_position?.department;

        return (
          <UserCard
            className={"break-word"}
            key={`member-card-${member.id}`}
            size={"md"}
            avatarUrl={getEmployeeAvatarUrl(member.employee, "4xl")}
            title={renderEmployeeName(member.employee)}
            to={`/employees/${member.employee.id}`}
            captionSlot={
              <Stack className={"text-base text-dark/60 px-2 whitespace-pre-wrap"}>
                {member.role != TeamMemberRoleType.member && (
                  <Text>{TeamMemberRoleItems().find((x) => x.id == member.role)?.title}</Text>
                )}
                <Text>{getEmployeePositionTitle(member.employee)}</Text>
                {division && <Text>{division.title}</Text>}
                {department && <Text>{department.title}</Text>}
              </Stack>
            }
          />
        );
      })}
    </Stack>
  );
}
